/**
 * Created by Litong on 17/9/1.
 */
import * as $ajax from '../router/http'
import * as Util from 'util'

// api版本
const prefix = Util.getApiVersion()

export function metaData (params) {
  let url = prefix + '/metadata/databox'

  if (params.path) {
    url += params.path
  } else {
    url += '/'
  }
  if (params.path_type) {
    url += '?path_type=' + params.path_type
  } else {
    url += '?path_type=ent'
  }
  if (params.offset) {
    url += '&offset=' + params.offset
  } else {
    url += '&offset=0'
  }
  if (params.limit) {
    url += '&limit=' + params.limit
  } else {
    url += '&limit=0'
  }
  if (params.sort) {
    url += '&sort=' + params.sort
  } else {
    url += '&sort=desc'
  }
  if (params.from) {
    url += '&from=' + params.from
  }
  if (params.prefix_neid) {
    url += '&prefix_neid=' + params.prefix_neid
  }
  if (params.orderBy) {
    url += '&orderby=' + params.orderBy
  } else {
    url += '&orderby=mtime'
  }
  if (params.content_type) {
    url += '&content_type=' + params.content_type
  }
  url += '&include_deleted=false&account_id=1&uid=27'

  return $ajax.ajaxGet(encodeURI(url))
}

export function info (params) {
  let url = prefix + '/info/databox'

  // /v2/info/databox/888?neid=463&path_type=ent&_=1504925615436&account_id=1&uid=27

  if (params.path) {
    url += params.path
  } else {
    url += '/'
  }
  if (params.path_type) {
    url += '?path_type=' + params.path_type
  } else {
    url += '?path_type=ent'
  }
  if (params.neid) {
    url += '&neid=' + params.neid
  }
  url += '&account_id=1&uid=27'

  return $ajax.ajaxGet(encodeURI(url))
}

export function search (params) {
  let url = prefix + '/search/databox'

  if (params.path) {
    url += '/' + params.path
  }

  // let LocalAPI = '/v2?query=' + this.searchInputValue + '&path_type=ent&include_deleted=false&_=1504083658659&account_id=1&uid=27'

  if (params.query) {
    url += '?query=' + params.query
  } else {
    url += '?query='
  }
  if (params.path_type) {
    url += '&path_type=' + params.path_type
  } else {
    url += '&path_type=ent'
  }
  if (params.page_size) {
    url += '&page_num=' + params.page_size
  } else {
    url += '&page_num=0'
  }
  if (params.offset) {
    url += '&offset=0'
  } else {
    url += '&offset=0'
  }
  if (params.sort) {
    url += '&sort=' + params.sort
  } else {
    url += '&sort=desc'
  }
  if (params.orderBy) {
    url += '&orderby=' + params.orderBy
  } else {
    url += '&orderby=mtime'
  }
  url += '&page_button_count=5&include_deleted=false&page_size=20&account_id=1&uid=27'

  return $ajax.ajaxGet(encodeURI(url))
}

export function batchDelete (params) {
  let url = prefix + '/fileops/batch_delete'

  // let LocalAPI = '/v2?query=' + this.searchInputValue + '&path_type=ent&include_deleted=false&_=1504083658659&account_id=1&uid=27'

  var json = {}
  json.pathes = []

  var obj = {}
  obj.root = 'databox'
  obj.neid = params.neid
  obj.path = params.path
  obj.from = params.from
  obj.path_type = params.path_type
  obj.prefix_neid = params.prefix_neid
  json.pathes.push(obj)
  if (params.ignore_share) {
    json.ignore_share = true
  }
  var postData = {'json': JSON.stringify(json)}
  url += '?d=1'

  return $ajax.ajaxPost(encodeURI(url), postData)
}
/**
 * 批量复制文件或目录。
 @param {object} params
 @param {function} params.callback 回调函数
 @param from 源路径
 @param to 目标路径
 */
export function copy (params) {
  var url = prefix + '/fileops/batch_copy'
  var data = JSON.stringify({
    from: [params.from],
    to: params.to
  })
  var postData = {'json': data}
  return $ajax.ajaxPost(encodeURI(url), postData)
}

export function rename (params) {
  let url = prefix + '/fileops/move'

  // let LocalAPI = '/v2?query=' + this.searchInputValue + '&path_type=ent&include_deleted=false&_=1504083658659&account_id=1&uid=27'

  var postData = {
    root: 'databox',
    from_path: params.path,
    from_path_type: params.from_path_type,
    from_from: params.from,
    from_neid: params.neid,
    from_prefix_neid: params.prefix_neid,
    to_path: params.to_path,
    to_path_type: params.to_path_type,
    to_from: params.from,
    to_prefix_neid: params.prefix_neid
  }
  if (params.ignore_share) {
    postData.ignore_share = true
  }
  url += '?d=1'
  return $ajax.ajaxPost(encodeURI(url), postData)
}

/**
 * 批量移动文件/目录。
 @param {object} params
 @param {function} params.callback 回调函数
 @param {string} params.from (数组) 源路径
 @param {string} params.to   目标路径
 @param {string} params.ignore_share   是否忽略共享
 */
export function move (params) {
  var url = prefix + '/fileops/batch_move'
  var data = {
    from: [params.from],
    to: params.to
  }
  if (params.ignore_share) {
    data.ignore_share = true
  }
  var postData = {json: JSON.stringify(data)}
  return $ajax.ajaxPost(encodeURI(url), postData)
}

/**
 * 创建目录。
 @param {object} params
 @param {string} params.path 文件路径
 @param {string} params.path_type 路径类型
 @param {string} params.from 共享者的uid
 @param {string} params.neid 父目录元数据ID
 @param {string} params.prefix_neid path的前缀的neid
 */
export function createFolder (params) {
  var uri = prefix + '/fileops/create_folder/databox' + params.path
  uri = uri.replace('//', '/')
  var postData = {}
  postData.is_update = false
  if (params.neid) {
    postData.neid = params.neid
  } else {
    if (params.path_type) postData.path_type = params.path_type
    if (params.from) postData.from = params.from
  }
  if (/^share/.test(params.path_type)) postData.prefix_neid = params.prefix_neid
  return $ajax.ajaxPost(uri, postData)
}
/**
 * 验证上传权限
 * @param params
 */
export function checkUploadAuth (params) {
  var uri = prefix + '/fileops/auth_upload/databox/'
  var getData = {
    path_type: params.path_type,
    bytes: params.bytes ? params.bytes : '0'
  }
  if (params.from) {
    getData.from = params.from
  }
  if (params.prefix_neid) {
    getData.prefix_neid = params.prefix_neid
  }
  if (params.iscloud) {
    getData.is_cloud = params.iscloud
  }
  var tmp = []
  if (params.path !== '') {
    uri += params.path
  }
  for (var i in getData) {
    if (getData[i]) {
      tmp.push(i + '=' + getData[i])
    }
  }
  uri += '?' + tmp.join('&')
  return $ajax.ajaxGet(encodeURI(uri))
}

/**
 * 获取文件历史版本
 * @param params
 * @returns {*}
 */
export function getHistory (params) {
  var url = prefix + '/revisions/databox'
  if (params.path) {
    url += params.path
  } else {
    url += '/'
  }
  if (params.neid) {
    url += '?neid=' + params.neid
  }
  return $ajax.ajaxGet(encodeURI(url))
}

/**
 * 删除文件历史版本
 * @param params
 * @returns {*}
 */
export function deleteHistory (params) {
  var url = prefix + '/revisions/databox'
  // if (params.path) {
  //   url += params.path
  // } else {
  //   url += '/'
  // }
  // if (params.neid) {
  //   url += params.neid
  // }
  return $ajax.ajaxGet(encodeURI(url))
}

/**
 * （新建收藏）
 @param {object} params
 @param {function} params.callback 回调函数
 @param {object} params.snapshot 这里存放metaData返回的数据
 */
export function setFavorite (params) {
  var uri = prefix + '/user/bookmark/create?account_id=1&uid=' + Util.getUserId()
  var json = {
    uid: params.uid,
    type: '1',
    neid: params.snapshot.neid,
    title: params.title || '',
    snapshot: params.snapshot
  }
  if (json.snapshot.desc) {
    json.snapshot.desc = json.snapshot.desc
  }
  json.snapshot.path = encodeURIComponent(json.snapshot.path)
  var postData = {'json': JSON.stringify(json)}
  return $ajax.ajaxPost(uri, postData)
}

/**
 * (查询收藏)
 @param {object} params
 @param {function} params.callback 回调函数
 @param {string} params.sort 排序规则 asc，desc
 @param {string} params.n 取多少条数据（默认是50）
 @param {string} params.p 当前第几页
 */
export function getFavorite (params) {
  var uri = 'v2/user/bookmark/list?sort=' + params.sort + '&order=' + params.order + '&n=' + params.n + '&p=' + params.p
  return $ajax.ajaxGet(encodeURI(uri))
}

/**
 * (批量取消收藏)
 @param {object} params
 @param {function} params.callback 回调函数
 @param {object} params.snapshot metaData返回的数据(数组)
 */
export function removeFavorite (params) {
  var uri = 'v2/user/bookmark/delete?account_id=1&uid=' + Util.getUserId()
  if (params.snapshot.length > 1) {
    for (var i = 0, len = params.snapshot.length; i < len; i++) {
      if (i === 0) {
        uri += '&id=' + params.snapshot[i].bookmark_id
      } else {
        uri += ',' + params.snapshot[i].bookmark_id
      }
    }
  } else if (params.snapshot.length === 1) {
    uri += '&id=' + params.snapshot[0].bookmark_id
  } else {
    uri += '&id=' + params.snapshot.bookmark_id
  }
  return $ajax.ajaxGet(encodeURI(uri))
}

/**
 * 将一个文件恢复到历史版本。
 @param {string} params.path 文件的路径
 @param {string} params.path_type 路径类型
 @param {string} params.from 共享者的uid 如:1343
 @param {string} params.neid 元数据ID 如:12343
 @param {string} params.rev 指定需要恢复的历史版本
 */
export function restore (params) {
  var url = prefix + '/restore/databox' + params.path
  var postData = {}

  if (params.neid) {
    postData.neid = params.neid
  } else {
    if (params.path_type) {
      postData.path_type = params.path_type
    }
    if (params.from) {
      postData.from = params.from
    }
  }
  if (params.rev) {
    postData.rev = params.rev
  }
  if (params.path_type === 'share_in' || params.path_type === 'share_out') {
    postData.prefix_neid = params.prefix_neid
  }
  return $ajax.ajaxPost(encodeURI(url), postData)
}




// WEBPACK FOOTER //
// ./src/SDK/FileManager.js